import React from 'react';
import { AIStarIcon } from './AIStarIcon';
import { FileErrorIcon } from './FileErrorIcon';

interface Props {
  errorMessage?: string;
  onRetry?: () => Promise<void>;
  onBack?: () => void;
}

export const ChatModalRetry = (props: Props) => {
  return (
    <div className="border border-gray-200 rounded-3 px-4 pb-4 d-flex flex-column shadow-sm mb-4">
      <div className="d-flex align-items-center justify-content-center gap-2">
        <AIStarIcon />
        <FileErrorIcon
          width={80}
          height={80}
        />
        <AIStarIcon />
      </div>

      <p className="inline-block text-center text-sm text-gray-500">{props.errorMessage}</p>

      <div className="d-flex justify-content-center align-items-center gap-2">
        <button
          className="btn btn-neutral"
          onClick={() => props.onBack?.()}
        >
          Back
        </button>
        <button
          className="btn btn-primary"
          onClick={() => props.onRetry?.()}
        >
          Retry
        </button>
      </div>
    </div>
  );
};
